import { LocalActivity } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

export const CreditsPill = ({
  credits,
  color,
}: {
  credits?: number;
  color?: string;
}) => {
  if (!credits) return null;
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 0.25,
        flexDirection: 'row',
        alignItems: 'center',
      }}>
      <LocalActivity
        sx={{ color: color ?? 'text.light', width: 12, height: 12 }}
      />
      <Typography variant="caption1Bold" color={color ?? 'text.light'}>
        {credits} Credit{credits === 1 ? '' : 's'}
      </Typography>
    </Box>
  );
};
